// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oDOSb","label":"styles_label__31DvC"};